import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { first, switchMap } from "rxjs/operators";
import { FromRouter, RootState } from "src/app/store";

@Injectable({ providedIn: "root" })
export class ProgramHeaderInterceptor implements HttpInterceptor {
  private readonly store = inject(Store<RootState>);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isUserAppServiceRequest(req)) {
      return next.handle(req);
    }

    return this.store.select(FromRouter.selectProgramId).pipe(
      first(),
      switchMap(programId => {
        if (programId) {
          req = req.clone({ setHeaders: { program: programId } });
        }
        return next.handle(req);
      }),
    );
  }

  private isUserAppServiceRequest(req: HttpRequest<unknown>): boolean {
    return req.url.includes("user-app-service");
  }
}
